import { render } from "./PatientDashboard.vue?vue&type=template&id=af8ef8dc&scoped=true"
import script from "./PatientDashboard.vue?vue&type=script&lang=js"
export * from "./PatientDashboard.vue?vue&type=script&lang=js"

import "./PatientDashboard.vue?vue&type=style&index=0&id=af8ef8dc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\PamelaOsunza\\OneDrive - dermapp.com\\Escritorio\\dermapp\\dermapp-pacientes-staging\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8ef8dc"]])

export default __exports__